import * as React from "react";
import AvatarPng from "./avatar.png";
import EmailPng from "./email.png";
import LockPng from "./lock.png";
import PhonePng from "./phone.png";
interface IconProps{
  width?: number;
  className?:string;
  onClick?: () => void;
}
export const IconAvatar = (props: IconProps) =>{
  return ( <img {...props} src={AvatarPng} alt={AvatarPng} />)
}
export const IconEmail = (props: IconProps) =>{
  return ( <img {...props} src={EmailPng} alt={EmailPng} />)
}
export const IconLock = (props: IconProps) =>{
  return ( <img {...props} src={LockPng} alt={LockPng} />)
}
export const IconPhone = (props: IconProps) =>{
  return ( <img {...props} src={PhonePng} alt={PhonePng} />)
}